import { defineMessages } from 'react-intl';

export const scope = 'app.components.accomodations';

export default defineMessages({
  plus_more: {
    id: `${scope}.plus_more`,
    defaultMessage: '+{count} more',
  },
});
